import React, { Component } from 'react';
import {
    withRouter
} from 'react-router-dom';
import {
    Text,
    // ProgressBar,
    BlockStack,
    Banner,
    Button,
    Pagination,
    Spinner,
    List,
    Modal,
    Tooltip,
    Checkbox,
    DropZone,
    Thumbnail,

} from '@shopify/polaris';
import {
} from '@shopify/polaris-icons';
import utils from '../../../../utils/utils';
import {
    reqUploadImagesOpt,
    reqUpdateIsDownload,
} from "../../../../api"
import ToastFunc from "../../../../components/ToastFunc";
import Language from '../../../../i18n/Language';
import TableFilters from '../../../../components/TableFilters';
import IndexTableImage from './IndexTableImage';
import FooterPageSelect from '../../../../components/FooterPageSelect/indexPage';
import cloneDeep from 'lodash-es/cloneDeep';
import ImageCompareModal from './ImageCompare';
import { showNewMessage } from '@intercom/messenger-js-sdk';
const t = Language;
class OptHistory extends Component {
    state = {
        page: this.props.page,                              // 分页
        pageSize: this.props.pageSize,
        queryValue: this.props.queryValue,                  // 搜索
        tabKey: this.props.tabKey,                          // 索引
        isShowAutoState: this.props.isShowAutoState,
        image_opt: this.props.image_opt,                    // 当前设置
        tableData: this.props.tableData,                    // 表格数据
        tableRes: this.props.tableRes,                      // 表格总数据
        tableLoading: this.props.tableLoading,              // 表格loading
        isShowProgress: this.props.isShowProgress,          // 进度条数据        
        progressCp: this.props.progressCp,                  // 进度条数据
        progressAll: this.props.progressAll,                // 进度条数据    
        optType: this.props.optType,                        // 进度条数据    
        optPageType: this.props.optPageType,                        // 进度条数据    
        tableItemState: [],                                 // 表格批量对象
        isShowUpload: false,
        impressionsUse: this.props.impressionsUse,
        impressionsAll: this.props.impressionsAll,
        exceedUse: this.props.exceedUse,
        exceedAll: this.props.exceedAll,
        is_capped: this.props.is_capped,
        is_over_quota: this.props.is_over_quota,
        level: this.props.level,
        isShowImgCompression: this.props.isShowImgCompression,
        Headings: [
            { title: '' },
            { title: t("Name") },
            { title: t("Status") },
            // { title: t("Reduction ratio") },
            // { title: t("Speed increase") },
            { title: t("Actions") },
        ],
        moreHeadings: [
            { title: '' },
            { title: t("Name") },
            { title: t("Status") },
            { title: t("File type") },
            // { title: t("Size") },
            // { title: t("Reduction ratio") },
            // { title: t("Speed increase") },
            { title: t("Actions") },
        ],
        CVImage: false,      // 转jpg状态
        AddWatermark: false, // 水印状态

        //图片上传
        files: [],
        rejectedFiles: [],
        imageData: [],

        ActionUpdateLoading: false, // 优化loading
        historyyPre: this.props.historyyPre, // 分页
        historyNext: this.props.historyNext, // 分页
        viewData: {}, // 查看优化对比数据
        loading: this.props.loading,
        isShowMaxLimitState: this.props.isShowMaxLimitState,
        handleTypePro: this.props.handleTypePro,
        handleTypeCol: this.props.handleTypeCol,
        handleTypeBlog: this.props.handleTypeBlog,
        isReOpt: this.props.isReOpt,

    }

    componentDidMount() {
        // 传递事件
        if (this.props.getEventAction) {
            this.props.getEventAction(this);
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.page !== this.props.page) {
            this.setState({
                page: nextProps.page
            })
        }
        if (nextProps.isShowAutoState !== this.props.isShowAutoState) {
            this.setState({
                isShowAutoState: nextProps.isShowAutoState
            })
        }
        if (nextProps.tabKey !== this.props.tabKey) {
            this.setState({
                tabKey: nextProps.tabKey
            })
        }
        if (nextProps.tableLoading !== this.props.tableLoading) {
            this.setState({
                tableLoading: nextProps.tableLoading,
            })
        }
        if (nextProps.image_opt !== this.props.image_opt) {
            this.setState({
                image_opt: nextProps.image_opt
            })
        }
        if (nextProps.queryValue !== this.props.queryValue) {
            this.setState({
                queryValue: nextProps.queryValue,
            })
        }
        if (nextProps.tableData !== this.props.tableData) {
            this.setState({
                tableData: nextProps.tableData,
                tableRes: nextProps.tableRes,
            })
        }
        if (nextProps.optType !== this.props.optType) {
            this.setState({
                optType: nextProps.optType,
            })
        }
        if (nextProps.optPageType !== this.props.optPageType) {
            this.setState({
                optPageType: nextProps.optPageType,
            })
        }
        if (nextProps.progressCp !== this.props.progressCp) {
            this.setState({
                isShowProgress: nextProps.isShowProgress,
                progressCp: nextProps.progressCp,
                progressAll: nextProps.progressAll,
                optType: nextProps.optType,
            })
        }
        if (nextProps.progressAll !== this.props.progressAll) {
            this.setState({
                progressCp: nextProps.progressCp,
                progressAll: nextProps.progressAll,
            })
        }
        if (nextProps.isShowProgress !== this.props.isShowProgress) {
            this.setState({
                isShowProgress: nextProps.isShowProgress,
                progressCp: nextProps.progressCp,
                progressAll: nextProps.progressAll,
                optType: nextProps.optType,
                optPageType: nextProps.optPageType,
            })
        }
        if (nextProps.loading !== this.props.loading) {
            this.setState({
                loading: nextProps.loading,
            })
        }
        if (nextProps.impressionsUse !== this.props.impressionsUse) {
            this.setState({
                impressionsUse: nextProps.impressionsUse,
                impressionsAll: nextProps.impressionsAll,
                exceedUse: nextProps.exceedUse,
                exceedAll: nextProps.exceedAll,
            })
        }
        if (nextProps.exceedUse !== this.props.exceedUse) {
            this.setState({
                exceedUse: nextProps.exceedUse,
                exceedAll: nextProps.exceedAll,
            })
        }
        if (nextProps.isShowImgCompression !== this.props.isShowImgCompression) {
            this.setState({
                isShowImgCompression: nextProps.isShowImgCompression,
            })
        }
        if (nextProps.historyyPre !== this.props.historyyPre) {
            this.setState({
                historyyPre: nextProps.historyyPre,
            })
        }
        if (nextProps.historyNext !== this.props.historyNext) {
            this.setState({
                historyNext: nextProps.historyNext,
            })
        }
        if (nextProps.is_capped !== this.props.is_capped) {
            this.setState({
                is_capped: nextProps.is_capped,
            })
        }
        if (nextProps.is_over_quota !== this.props.is_over_quota) {
            this.setState({
                is_over_quota: nextProps.is_over_quota,
            })
        }
        if (nextProps.isShowMaxLimitState !== this.props.isShowMaxLimitState) {
            this.setState({
                isShowMaxLimitState: nextProps.isShowMaxLimitState,
            })
        }
        if (nextProps.handleTypePro !== this.props.handleTypePro) {
            this.setState({
                handleTypePro: nextProps.handleTypePro,
            })
        }
        if (nextProps.handleTypeCol !== this.props.handleTypeCol) {
            this.setState({
                handleTypeCol: nextProps.handleTypeCol,
            })
        }
        if (nextProps.handleTypeBlog !== this.props.handleTypeBlog) {
            this.setState({
                handleTypeBlog: nextProps.handleTypeBlog,
            })
        }
        if (nextProps.isReOpt !== this.props.isReOpt) {
            this.setState({
                isReOpt: nextProps.isReOpt,
            })
        }

        return true
    }

    // 切换tab
    handleTypeTabsChange = (e) => {
        this.props.handleTypeTabskeyChange(e);
    }

    // 搜索
    setQueryValue = (val) => {
        this.props.changeHistoryQueryVal(val)
    }

    // 状态切换 正负
    handleOptHistoryState = (val, name) => {
        this.setState({
            [name]: val
        })

        if (!Boolean(val) && name === 'isShowUpload') {
            this.setState({
                files: [],
                rejectedFiles: [],
                imageData: [],
            })
        }
    }

    // 上传图片
    handleDrop = (_droppedFiles, acceptedFiles, rejectedFiles) => {
        this.setState({
            files: [...this.state.files, ...acceptedFiles],
            rejectedFiles: rejectedFiles
        }, () => {
            this.handleDropImage()
        });
    }

    //图片数据加载
    handleDropImage = () => {
        let imageData = [];
        for (let i = 0; i < this.state.files.length; i++) {
            const filesImg = this.state.files[i];
            // 开启FileReader
            let reader = new FileReader();
            reader.readAsDataURL(filesImg); //读取文件保存在result中
            reader.onload = (e) => {
                let getRes = e.target.result;//读取的结果在result中
                imageData.push(
                    {
                        'name': filesImg.name,
                        'data': getRes,
                        'type': filesImg.type,
                    }
                );
            }
        }

        this.setState({
            imageData: imageData
        });
    }

    // 获取table批量数据
    getTableItemState = (val) => {
        this.setState({
            tableItemState: val
        }, () => {
            this.props.setTableSelect(val[1]);
        })
    }

    // 单个恢复
    RestoreImageData = (data) => {
        this.props.RestoreHitoryImageData(data);
    }

    // 批量恢复
    optRestoreImage = async () => {
        let { tableItemState } = this.state;
        this.props.BatchReHitoryImageData(tableItemState);
    }

    // 批量重新优化
    ReOptimizeImage = async () => {
        let { tableItemState } = this.state;
        this.props.BatchOptHitoryImageData(tableItemState);
    }

    // 上传图片优化 - 转向other
    handleChangeRedirectSave = (name) => {
        //添加图片
        let { files, imageData, CVImage, AddWatermark } = this.state;
        this.setState({
            ActionUpdateLoading: true
        }, async () => {
            if (files.length > 0) {
                //用户自动填写的数据
                let params = {
                    file_list: imageData,
                    opt_cfg: {
                        pngtojpg: Number(CVImage),
                        is_watermark: Number(AddWatermark)
                    }
                }
                const response = await reqUploadImagesOpt(params);
                if (response.ack === 1) {
                    this.toggleToast(response.msg, false);
                    this.setState({
                        ActionUpdateLoading: false,
                    }, () => {
                        this.handleOptHistoryState(false, 'isShowUpload');
                        this.props.handleTypeTabskeyChange(3);
                    })
                } else {
                    this.setState({
                        ActionUpdateLoading: false,
                    })
                    this.toggleToast(response.msg, true);
                }
            } else {
                this.setState({
                    ActionUpdateLoading: false,
                    files: [],
                    rejectedFiles: [],
                }, () => {
                    this.toggleToast(t("haven't uploaded image"), true);
                });
            }
        });
    }

    // 跳转详情
    jumpOptImgDetails = (data) => {
        utils.routeJump(this, '/on-page-seo/image-alt-text/details', { id: data.prod_id, title: data.title })
    }

    // 打开对比图弹窗
    openDetailCompareModal = (data) => {
        this.setState({
            isShowCompareImage: true,
            imageModalLoading: true,
            viewData: data
        }, () => {
            setTimeout(() => {
                // 过渡图片加载时间，防止跳动过大
                this.setState({
                    imageModalLoading: false,
                })
            }, 500)
        })
    }

    // 关闭对比弹窗
    closeImageCompare = () => {
        this.setState({
            isShowCompareImage: false,
            imageModalLoading: false,
        })
    }

    // 下载图片
    DownloadImage = (data) => {
        let { tabKey, tableData } = this.state;
        let list = cloneDeep(tableData);
        let url = (tabKey === 1 || tabKey === 2) ? (Boolean(data.image?.is_restore) ? data['image']['before_file_path'] : data['image']['after_file_path']) : data['after_file_path'];
        let filename = (tabKey === 1 || tabKey === 2) ? data['image']['file_name'] : data['file_name'];
        list.forEach(item => {
            if (item['id'] === data['id'] && !Boolean(item['downloadLoadingId'].includes(data['id']))) {
                item['downloadLoadingId'].push(data['id']);
            }
        })
        this.setState({
            tableData: list
        }, async () => {
            if (Boolean(url)) {
                // utils.downloadImage(url, filename)
                if (url.startsWith('http:')) {
                    const replaceUrl = url.replace('http:', 'https:');
                    utils.downloadImage(replaceUrl, filename).then(res => {
                        if (!res) {
                            this.toggleToast(t("Invalid link"), true);
                        }
                    })
                } else {
                    utils.downloadImage(url, filename).then(res => {
                        if (!res) {
                            this.toggleToast(t("Invalid link"), true);
                        }
                    })
                }
                let id = (tabKey === 1 || tabKey === 2) ? data['image']['id'] : data['id'];
                this.requestDownload(id, data['id']);
            } else {
                this.toggleToast(t("Invalid link"), true);
            }
            // let header = new Headers({
            //     Origin: window.location.origin,
            // })
            // fetch(url, {
            //     headers: header,
            //     mode: 'cors',
            // })
            //     .then(res => res.blob())
            //     .then(async (blob) => {
            //         const blobUrl = window.URL.createObjectURL(blob)
            //         utils.downloadImage(blobUrl, filename)
            //         window.URL.revokeObjectURL(blobUrl);
            //         let id = (tabKey === 1 || tabKey === 2) ? data['image']['id'] : data['id'];
            //         this.requestDownload(id);
            //     })
        })

    }
    download(href, filename = '') {
        window.open(href);
        // const a = document.createElement('a')
        // a.download = filename
        // a.href = href
        // document.body.appendChild(a)
        // a.click()
        // a.remove()
    }

    // 发起下载成功请求
    requestDownload = async (id, oid) => {
        let params = {
            opt_id: id
        }
        const res = await reqUpdateIsDownload(params);
        if (res) {
            let { tableData } = this.state;
            let list = cloneDeep(tableData);
            list.forEach(item => {
                let indexId = item['downloadLoadingId'].indexOf(oid);
                if (item['id'] === oid && indexId > -1) {
                    item['downloadLoadingId'].splice(indexId, 1);
                }
            })
            this.setState({
                tableData: list
            })
        }
    }

    // 分页
    changeHitoryTablePage = (e) => {
        this.props.changeHitoryTablePageData(e);
    }

    // 页数
    changePageSizeData = (s) => {
        this.props.changeHitoryTablePageSizeData(s);
    }

    // 打开设置
    openSettingCard = () => {
        this.handleOptHistoryState(false, 'isShowUpload')
        this.props.openSettingCard();
    }

    //提示弹窗
    toggleToast = (showToastText, showToastIserror) => {
        this.setState({
            showToast: false
        }, () => {
            this.setState(({ showToast }) => ({
                showToast: !showToast,
                showToastText: showToastText,
                showToastIserror: showToastIserror
            }));
        });
    };

    //点击联系客服
    handleContactService = () => {
        try {
            showNewMessage()
        } catch (e) {
            this.toggleToast(t("Try again later"), true);
        }
    }

    render() {
        const {
            showToast,
            showToastText,
            showToastIserror,
            queryValue,
            tabKey,
            isShowUpload,
            tableLoading,
            Headings,
            moreHeadings,
            // otherHeadings,
            tableData,
            tableRes,
            isShowAutoState,
            image_opt,
            // CVImage,
            AddWatermark,
            files,
            rejectedFiles,
            ActionUpdateLoading,
            historyyPre,
            historyNext,
            page,
            isShowCompareImage,
            imageModalLoading,
            viewData,
            isShowProgress,
            // progressCp,
            // progressAll,
            // optType,
            // optPageType,
            loading,
            impressionsUse,
            impressionsAll,
            exceedUse,
            exceedAll,
            is_capped,
            // is_over_quota,
            isShowImgCompression,
            level,
            isShowMaxLimitState,
            handleTypePro,
            handleTypeCol,
            handleTypeBlog,
            isReOpt,

        } = this.state;

        // 提示弹窗
        const toastMarkup = showToast ? <ToastFunc content={showToastText} onDismiss={showToast} error={showToastIserror} /> : null;

        // 历史表格标题
        const historyHeading = tabKey === 0 ? Headings : moreHeadings;

        // 对比图片弹窗
        const compareImageModal = <ImageCompareModal
            type={(tabKey === 1 || tabKey === 2) ? 'public' : 'other'}
            viewData={viewData}
            isShowCompareImage={isShowCompareImage}
            imageModalLoading={imageModalLoading}
            closeImageCompare={this.closeImageCompare}
        />

        // 分页
        const footerContentText = <FooterPageSelect
            page={tableRes.current_page}
            current_PageSize={tableRes.per_page}
            total={tableRes.total}
            changePageSize={this.changePageSizeData}
            handlePageBlur={this.props.handlePageBlur}
        />

        // 上传提示
        const errorMessage = rejectedFiles.length > 0 && (
            <Banner
                title={t("The following images couldn't be uploaded:")}
                tone="critical"
                action={{
                    content: t("Contact us"),
                    onAction: this.handleContactService
                }}
                onDismiss={() => {
                    this.setState({
                        rejectedFiles: [],
                    })
                }}
            >
                <List type="bullet">
                    {rejectedFiles.map((file, index) => (
                        <List.Item key={index}>
                            {`"${file.name}"` + t("is not supported. File type must be .jpg, .png.")}
                        </List.Item>
                    ))}
                </List>
            </Banner>
        );
        // 上传图片弹窗
        const fileUpload = !files.length && <DropZone.FileUpload actionTitle={t("Add image")} actionHint={t("Accepts .jpg, and .png")} />;
        const uploadedFiles = files.length > 0 && (
            <BlockStack>
                <div className='opt_image_upload'>
                    {files.map((file, index) => (
                        <BlockStack gap={100} key={index}>
                            <Thumbnail
                                size="large"
                                alt={file.name}
                                source={window.URL.createObjectURL(file)}
                            />
                            <Text variant="bodySm" as="p">{file.name}</Text>
                            <Text variant="bodySm" as="p">{changeBitInfo(file.size)}</Text>
                        </BlockStack>
                    ))}
                </div>
            </BlockStack>
        );
        const uploadImgModal = <Modal
            open={isShowUpload}
            onClose={() => this.handleOptHistoryState(false, 'isShowUpload')}
            title={t("Upload images to optimize")}
            primaryAction={(impressionsUse < impressionsAll) || (exceedUse < exceedAll && level !== 3) || (exceedUse <= exceedAll && exceedAll >= 0 && exceedUse < 20000 && is_capped && level === 3) || (level === 3 && !isShowMaxLimitState) ? {
                content: t("Optimize now"),
                onAction: this.handleChangeRedirectSave,
                loading: ActionUpdateLoading,
                disabled: files.length === 0
            } : {
                content: t("Upgrade plan"),
                onAction: () => {
                    utils.routeJump(this, "/plan")
                },
            }}
        >
            <div style={{ padding: '1rem' }}>
                <BlockStack gap={200}>
                    {errorMessage}
                    <DropZone
                        accept="image/png,image/jpeg,image/jpg"
                        type="image"
                        errorOverlayText="File type must be .jpg .jpeg .png."
                        onDrop={this.handleDrop}
                    >
                        {uploadedFiles}
                        {fileUpload}
                    </DropZone>
                    <div className='imgSet_item'>
                        {/* <Checkbox
                            label={t("Convert PNG to JPG")}
                            id={"CVImage"}
                            checked={CVImage}
                            onChange={this.handleOptHistoryState}
                        /> */}
                        {(Boolean(isShowImgCompression) && Boolean(image_opt.watermark?.switch)) ? <Checkbox
                            label={t("Add watermark")}
                            id={"AddWatermark"}
                            checked={AddWatermark}
                            onChange={this.handleOptHistoryState}
                        /> : <label onClick={this.openSettingCard}>
                            <Tooltip content={
                                <Text as="p" fontWeight="semibold">{t("You should")}&nbsp;<span style={{ color: 'var(--p-color-text-emphasis)', cursor: 'pointer' }}>{t("upload watermark picture")}</span></Text>
                            }>
                                <Checkbox
                                    label={t("Add watermark")}
                                    id={"AddWatermark"}
                                    disabled={true}
                                    checked={false}
                                />
                            </Tooltip>
                        </label>}
                    </div>
                </BlockStack>
            </div>
        </Modal>

        // 判断批量
        const bulkOperaBox = (isShowProgress === tabKey || isShowAutoState) ? [
            {
                content: <Tooltip content={
                    isShowAutoState ? t("This feature is only available when the 'Auto Add Image Alt Text' function is disabled.") :
                        (tabKey === 0 && handleTypePro === 1) || (tabKey === 1 && handleTypeCol === 1) || (tabKey === 2 && handleTypeBlog === 1) ?
                            t("Please wait: Alt optimization in progress (Operation available after completion)") :
                            t("Please wait: Image optimization in progress (Operation available after completion)")
                }>
                    <span>{t("Restore")}</span>
                </Tooltip>,
                disabled: true
            },
            {
                content: <Tooltip content={
                    isShowAutoState ? t("This feature is only available when the 'Auto Add Image Alt Text' function is disabled.") :
                        (tabKey === 0 && handleTypePro === 1) || (tabKey === 1 && handleTypeCol === 1) || (tabKey === 2 && handleTypeBlog === 1) ?
                            t("Please wait: Alt optimization in progress (Operation available after completion)") :
                            t("Please wait: Image optimization in progress (Operation available after completion)")
                }>
                    <span>{t("Re-optimize")}</span>
                </Tooltip >,
                disabled: true
            },
        ] : [
            {
                content: t("Restore"),
                onAction: this.optRestoreImage,
            },
            {
                content: t("Re-optimize"),
                onAction: this.ReOptimizeImage,
            },
        ]

        // 最终页面
        const pageContent = <div className={`optimize_history ${(isShowProgress === tabKey || isShowAutoState) ? 'isAutoDisabled' : ''}`}>
            <TableFilters
                // loading={tableLoading}
                itemStrings={[
                    t("Product"),
                    t("Collection"),
                    t("Blog"),
                    // t("Other"),
                ]}
                queryValue={queryValue}
                typeSelected={tabKey}
                setSelectedTabsIndex={(e) => this.handleTypeTabsChange(e)}
                setQueryValue={(v) => this.setQueryValue(v)}
            />
            {
                isShowAutoState ? <div className='flex_layout auto_opt_tip'>
                    <Text variant="headingXs" as="h6">{t("Automatically optimizing")}</Text>
                    <Spinner size='small' />
                </div> : (isShowProgress !== -1 && isShowProgress === tabKey) ? null : null
            }
            {/* {
                isShowAutoState ? <div className='flex_layout auto_opt_tip'>
                    <Text variant="headingXs" as="h6">{t("Automatically optimizing")}</Text>
                    <Spinner size='small' />
                </div> : (isShowProgress !== -1 && isShowProgress === tabKey) ? <div className='opt_progress_hitory'>
                    <div className='flex_layout'>
                        <div className='flex_layout auto_opt_tip'>
                            <Text variant="headingXs" as="h6">
                                {
                                    optType === 'restore' ? t("Restoring") : (optType === 're-Optimize' && optPageType === 0) ? t("Re-optimizing") : t("Manually optimization progress")
                                }
                            </Text>
                            <Spinner size='small' />
                        </div>
                        <span>{t("completed")}/{t("all")}:&nbsp;&nbsp;{progressCp}/{progressAll}</span>
                    </div>
                    {
                      progressAll > 0 && <ProgressBar progress={Number(((progressCp/progressAll) * 100).toFixed(0))} size='small' />
                    }
                </div> : null
            } */}
            {
                tableLoading ? <div className='table_loading'><Spinner /></div> : <IndexTableImage
                    id={`History_Table_${tabKey}`}
                    tabKey={tabKey}
                    headings={historyHeading}
                    dataList={tableData}
                    loading={loading}
                    isShowAutoState={isShowAutoState}
                    total={tableRes.total}
                    isShowProgress={isShowProgress}
                    obj_name={tabKey === 0 ? 'products' : tabKey === 1 ? 'collections' : 'blogs'}
                    getTableItemState={this.getTableItemState}
                    promotedBulkActions={bulkOperaBox}
                    tableType={'history'}
                    jumpOptImgDetails={this.jumpOptImgDetails}
                    openDetailCompareModal={this.openDetailCompareModal}
                    RestoreImageData={this.RestoreImageData}
                    DownloadImage={this.DownloadImage}
                    isReOpt={isReOpt}
                />
            }
            {/* 分页 */}
            {
                tableLoading ? null :
                    (tableData.length > 0 && <div className='justify_center sticky_footer'>
                        <Pagination
                            label={footerContentText}
                            hasPrevious={historyyPre}
                            onPrevious={() => this.changeHitoryTablePage(page - 1)}
                            hasNext={historyNext}
                            onNext={() => this.changeHitoryTablePage(page + 1)}
                        />
                    </div>)
            }

            {/* 图片对比弹窗 */}
            {compareImageModal}

            {/* 上传图片弹窗 */}
            {uploadImgModal}

            {toastMarkup}
        </div>

        return pageContent;
    }

}
function changeBitInfo(limit) {
    // 比特转换
    let size = "";
    if (limit < 1 * 1024 * 1024) {
        //小于0.1MB，则转化成KB 
        size = (limit / 1024).toFixed(2) + "KB"
    } else if (limit < 1 * 1024 * 1024 * 1024) {
        //小于0.1GB，则转化成MB 
        size = (limit / (1024 * 1024)).toFixed(2) + "MB"
    } else {
        //其他转化成GB 
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB"
    }
    return size;
}

export default withRouter(OptHistory);
